export const FETCH_REQUEST = "FETCH_REQUEST";
export const FETCH_REQUESTS = "FETCH_REQUESTS";
export const FETCH_LISTINGS = "FETCH_LISTINGS";